// src/store/features/billers/billerSlice.ts
import { createSlice } from "@reduxjs/toolkit";
import { BillerState } from "./billerTypes";
import {
  fetchBillersRequest,
  fetchBillersSuccess,
  fetchBillersFailure,
  selectBiller,
  clearSelectedBiller,
  getBillerByCategoryRequest,
} from "./billerActions";

const initialState: BillerState = {
  loading: false,
  error: null,
  billers: [],
  selectedBiller: null,
};

const billerSlice = createSlice({
  name: "billers",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBillersRequest, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getBillerByCategoryRequest, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBillersSuccess, (state, action) => {
        // console.log("fetchBillersSuccess", action.payload);

        state.loading = false;
        state.billers = action.payload;
      })
      .addCase(fetchBillersFailure, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(selectBiller, (state, action) => {
        state.selectedBiller = action.payload;
      })
      .addCase(clearSelectedBiller, (state) => {
        state.selectedBiller = null;
      });
  },
});

export default billerSlice.reducer;

// export const billerActions = {
//   fetchBillersRequest,
//   fetchBillersSuccess,
//   fetchBillersFailure,
//   selectBiller,
// };
